<div class="container-background container-fluid content pb-5" (window:resize)="onResize()">
  @if (showNavBar) {
    <ul class="nav nav-tabs mt-2">
      <a class="nav-link nav-item" routerLink="/rt2012/suivi-des-consommations">Suivi</a>
      <a class="nav-link nav-item active">Comparaison</a>
    </ul>
  }

  <div class="row">
    <div class="page-title col-12">
      <h2>Comparaison de vos consommations en kWh</h2>
    </div>
  </div>

  <div class="m-2 p-4 bg-white rounded">
    @if (null !== user && (hasEnedisAccessToken || hasGazparAccessToken) && loadingTerminate) {
      <form [formGroup]="searchForm" (ngSubmit)="reloadSearch()">
        <div class="col-12 row compare-container">
          <div class="col-12">
            <p>
              Vous avez fait des travaux ou modifié vos habitudes de consommation d’énergie ?
            </p>
            <p>
              Vous souhaitez simplement mesurer l’évolution de votre consommation d’énergie?
            </p>
            <h6><strong>Choisissez les @if (energiesAvailables?.length > 1) {
              <span>énergies et</span>
              } périodes
            que vous souhaitez comparer :</strong></h6>
          </div>
          <div class="input-wrapper input-group col-lg-6 col-md-6 col-sm-12">
            <div class="col-12 period-bloc gray-period">
              <div class="input-wrapper input-group col-lg-6 col-md-6 col-sm-12">
                @if ((energiesAvailables?.length || this.hasEnedisAccessToken || this.hasGazparAccessToken)) {
                  <div class="row">
                    <label for="selectedEnergie" class="col-sm-auto">Énergie en kWh:</label>
                    <div class="col-sm-auto">
                      <select class="form-control" id="selectedEnergie" (change)="updateSelectedEnergie($any($event.target).value)">
                        @if (energiesAvailables?.length > 1) {
                          <option>Electricité et Gaz</option>
                        }
                        @for (energie of energiesAvailables; track energie) {
                          <option [ngValue]="energie">{{ energie }}</option>
                        }
                      </select>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="col-12 period-bloc green-period">
              <label for="startDateModelFirstPeriod"><u><strong>1ère Période</strong> (la plus ancienne):</u></label>
              <div class="input-group input-group-wrapper">
                <label class="input-label m-2 col-1">du</label>
                <input class="col-11 calender-input form-control"
                  id="startDateModelFirstPeriod"
                  type="date"
                  (change)="changeStatus()"
                  formControlName="startDateModelFirstPeriod"
                  value="{startDateModelFirstPeriod}"
                  placeholder="yyyy-mm-dd">
                <label class="input-label m-2 col-1">au</label>
                <input class="col-11 calender-input form-control"
                  id="endDateModelFirstPeriod"
                  type="date"
                  (change)="changeStatus()"
                  formControlName="endDateModelFirstPeriod"
                  placeholder="yyyy-mm-dd">
              </div>
            </div>
            <div class="col-12 period-bloc orange-period">
              <label for="startDateModelSecondPeriod"><u><strong>2ème Période</strong> (la plus récente):</u></label>
              <div class="input-group input-group-wrapper">
                <label class="input-label m-2 col-1">du</label>
                <input class="col-11 calender-input form-control"
                  id="startDateModelSecondPeriod"
                  type="date"
                  (change)="changeStatus()"
                  formControlName="startDateModelSecondPeriod"
                  placeholder="yyyy-mm-dd">
                <label class="input-label m-2 col-1">au</label>
                <input class="col-11 calender-input form-control input-disabled" type="text" [value]="consumptionData.secondEndDate" data-bs-toggle="tooltip" data-delay="1" title="Cette date est calculée automatiquement pour que la 2eme période soit de durée identique à la 1ère" disabled>
              </div>
            </div>
          </div>
          <div class="input-group col-lg-2 col-md-2 col-sm-12">
            @if (changed) {
              <button type="submit" class="btn-recherche btn btn-light px-3" title="Refresh les resultats"><fa-icon [icon]="faReload"></fa-icon></button>
            }
          </div>
          <div class="result-resume input-group col-lg-4 col-md-4 col-sm-12">
            <p class="result-resume-phrase">
              <u><strong>Résultat</strong></u>: votre consommation d’énergie à varié de <strong>{{consumptionData.gauge.diff_kwh > 0 ? '+' : ''}}{{consumptionData.gauge.diff_kwh}} kWh</strong>, soit l'équivalent de <strong>{{consumptionData.gauge.diff_co2 > 0 ? '+' : ''}}{{consumptionData.gauge.diff_co2}} kg de CO²</strong>
            </p>
          </div>
        </div>
      </form>
      <div class="col-12 pt-5 w-100 row graphs-wrapper">
        <div class="col-md-8 col-sm-12" style="align-self: center;" [@rotatedState]='state' >
          @if (consumption | async) {
            <app-consumption-line-graph   [multiLines]="consumptionData.graph"></app-consumption-line-graph>
          }
        </div>
        <div class="col-md-4 col-sm-12">
          @if (consumption | async) {
            <app-gauge [gauge]="consumptionData.gauge"></app-gauge>
          }
        </div>
      </div>
    }
    @if (logement?.statut !== 'FERME') {
      @if ((energiesEditables.includes(EnergieEnum.GAZ) || logement.getNatureChauffage() == EnergieEnum.GAZ || logement.getNatureEauChaude() == EnergieEnum.GAZ) && null !== user && !hasGazparAccessToken && loadingTerminate) {
        <div class="row w-100 mt-3">
          <div class="offset-4 col-4 d-flex justify-content-center">
            <div class="d-flex align-items-center m-auto">
              <span class="d-none d-sm-block ms-3 h5 me-3">Données Gazpar</span><br>
              <button class="btn btn-linky d-sm-inline-block" (click)="getFromGazpar()" >
                <img src="assets-front/images/vert-gazpar.png" style="height: 56px">
              </button>
            </div>
          </div>
          <div class="col-2">
            <ng-container>
              <img id="help-arrow-gazpar" src="/assets-front/images/arrow_right.svg" alt="flêche droite" class="d-none d-sm-none d-md-inline-block" [@rubberBandOnEnter]>
            </ng-container>
          </div>
          <div class="col-12 d-flex justify-content-center">
            <div class="d-flex align-items-center m-auto btn-linky-legende">
              <div>En cliquant sur ce bouton, vous allez accéder à votre compte personnel GRDF où vous pourrez donner votre accord pour que GRDF nous transmette vos données.</div>
            </div>
          </div>
        </div>
      }
      @if (null !== user && !hasEnedisAccessToken && loadingTerminate) {
        <div class="row w-100" matomoClickCategory="Consommations" matomoClickAction="click" matomoClickName="conso_lien_linky">
          <div class="offset-4 col-4 d-flex justify-content-center">
            <div class="d-flex align-items-center m-auto">
              <span class="d-none d-sm-block ms-3 h5 me-3">Données Linky</span><br>
              <button class="btn btn-linky d-sm-inline-block" (click)="getFromLinky()" >
                <img src="assets-front/images/vert-enedis.png">
              </button>
            </div>
          </div>
          <div class="col-2">
            <ng-container>
              <img id="help-arrow-enedis" src="/assets-front/images/arrow_right.svg" alt="flêche droite" class="d-none d-sm-none d-md-inline-block" [@rubberBandOnEnter]>
            </ng-container>
          </div>
          <div class="col-12 d-flex justify-content-center">
            <div class="d-flex align-items-center m-auto btn-linky-legende">
              <div>En cliquant sur ce bouton, vous allez accéder à votre compte personnel Enedis où vous pourrez donner votre accord pour qu’Enedis nous transmette vos données.</div>
            </div>
          </div>
        </div>
      }
    }
    @if (!loadingTerminate) {
      <div class="offset-md-12 messages">
        <span>Chargement des données de consommation en cours ...</span>
      </div>
    }
  </div>
</div>
